<template>
    <div class="row wrap">
        <div class="col-6">
            <input-text v-model="label.x_coord" :label="$t('Coord X')" after="px" @change="label.save()"/>
        </div>
        <div class="col-6">
            <input-text v-model="label.y_coord" :label="$t('Coord Y')" after="px" @change="label.save()"/>
        </div>
        <div class="col-12">
            <input-media v-model="label.image" :label="$t('Image')" :storie-id="label.getStoryId()" @change="label.save()"/>
        </div>
        <div class="col-6">
            <input-text v-model="label.diameter" :label="$t('Diameter')" after="px" @change="label.save()"/>
        </div>
        <div class="col-12">
            <Pointer_Edit :label="label"></Pointer_Edit>
        </div>
    </div>
</template>

<script>
    import InputText from "@/modules/input/input-text";
    import InputMedia from "@/modules/input/input-media";
    import Btn from "@/modules/buttons/btn";
    import {label} from "@/class/label";
    import Pointer_Edit from "@/modules/labels/Pointer_Edit";

    export default {
        name: "Markers_Edit",
        components: {Pointer_Edit, Btn, InputMedia, InputText},
        props:{
            label:{type:Object, default : () => new label()}
        },
    }
</script>